export const GA_MEASUREMENT_ID = 'G-XXP2DQJRR8';

export const pageview = (url) => {
  if (!window.gtag) return;
  // either use config with page_path or fire page_view event
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

export const event = ({ action, category, label, value }) => {
  if (!window.gtag) return;
  window.gtag('event', action, {
    category: category,
    label: label,
    value,
  });
};
